/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MediaList_media$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MediaCollectionList_mediaCollectionMedia$ref: FragmentReference;
declare export opaque type MediaCollectionList_mediaCollectionMedia$fragmentType: MediaCollectionList_mediaCollectionMedia$ref;
export type MediaCollectionList_mediaCollectionMedia = {|
  +mediaList: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string
      |}
    |}>,
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
    +$fragmentRefs: MediaList_media$ref,
  |},
  +$refType: MediaCollectionList_mediaCollectionMedia$ref,
|};
export type MediaCollectionList_mediaCollectionMedia$data = MediaCollectionList_mediaCollectionMedia;
export type MediaCollectionList_mediaCollectionMedia$key = {
  +$data?: MediaCollectionList_mediaCollectionMedia$data,
  +$fragmentRefs: MediaCollectionList_mediaCollectionMedia$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "MediaCollectionList_mediaCollectionMedia",
  "type": "ExtendedMediaConnection",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "mediaList"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchCategory",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "fetchAllPhotos",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "cursor",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "minTime",
      "type": "NaiveDatetime"
    },
    {
      "kind": "RootArgument",
      "name": "maxTime",
      "type": "NaiveDatetime"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "mediaList",
      "name": "__MediaCollectionList_mediaList_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "afterShotDate",
          "variableName": "minTime"
        },
        {
          "kind": "Variable",
          "name": "beforeShotDate",
          "variableName": "maxTime"
        }
      ],
      "concreteType": "MediaConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Media",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "MediaList_media",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1d75cfdc84536fb755de168c5f310198';

module.exports = node;
